document.addEventListener('DOMContentLoaded', function () {
  // Lightbox-Element erstellen
  const lightbox = document.createElement('div');
  lightbox.id = 'custom-lightbox';
  lightbox.innerHTML = `
    <div id="lightbox-overlay">
      <button id="lightbox-close">&times;</button>
      <img id="lightbox-img" src="" alt="">
    </div>
  `;
  document.body.appendChild(lightbox);

  // Galerie-Bilder mit Klick-Event versehen
document.querySelectorAll('.ai-portfolio-gallery__image-atg5umwpns2g3muvsuaigenblockf1ca7ccajncxk').forEach(img => {
    img.style.cursor = 'pointer';
    img.addEventListener('click', function () {
     // URL-Parameter entfernen um das Originalbild zu laden
const originalSrc = this.src.split('?')[0];
document.getElementById('lightbox-img').src = originalSrc;
      document.getElementById('custom-lightbox').style.display = 'flex';
    });
  });

  // Schließen per X-Button
  document.getElementById('lightbox-close').addEventListener('click', closeLightbox);
  // Schließen per Klick außerhalb
  document.getElementById('lightbox-overlay').addEventListener('click', function (e) {
    if (e.target === this) closeLightbox();
  });
  // Schließen per ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
  });

  function closeLightbox() {
    document.getElementById('custom-lightbox').style.display = 'none';
  }
});
